import React, {Component} from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'components/ReactRouterDomLocalized';

const { connect } = require('react-redux');
import Modal from 'react-bootstrap-modal';

import ModalMenuLoginForm from './ModalMenu/ModalMenuLoginForm';
import ModalMenuSignupForm from './ModalMenu/ModalMenuSignupForm';
import ModalMenuForgotPasswordForm from './ModalMenu/ModalMenuForgotPasswordForm';
import ModalMenuPasswordChangeForm from './ModalMenu/ModalMenuPasswordChangeForm';
import ModalMenuUserBlock from './ModalMenu/ModalMenuUserBlock';
import ModalMenuConfirmRegistration from './ModalMenu/ModalMenuConfirmRegistration';
import LangButton from 'components/modals/LangButton';

import {logout, setCurrentUser} from 'reducers/currentUser';

import {t} from 'l10n';

import paths from 'paths';

import 'sass/modals/userModal.scss';

//let fsIcon = require('images/icons/fs.png'),
//    twitterIcon = require('images/icons/twitter.png');

class ModalMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: null,
            registeredEmail: ''
        };

        this.onRegisterSuccess = this.onRegisterSuccess.bind(this);
        this.onLogout = this.onLogout.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.currentUser.isLoggedIn() && nextProps.currentUser.isLoggedIn()) {
            if (nextProps.modal == 'login' && nextProps.returnPath) {
                this.setState({redirect: nextProps.returnPath});
            }
        }

        if (this.props.currentUser.isLoggedIn() && !nextProps.currentUser.isLoggedIn()) {
            this.props.closeFn();
        }

        if (this.props.show && !nextProps.show) {
            this.setState({redirect: null});
        }
    }

    onRegisterSuccess(response) {
        const {dispatch} = this.props;

        dispatch(setCurrentUser(response.user));

        this.setState({ registeredEmail: response.user.email });
    }

    onLogout() {
        const {dispatch} = this.props;

        dispatch(logout());
    }

    render() {
        let {show, modal, currentUser, pm, closeFn, logout, prt, showDelete} = this.props;
        let {redirect, registeredEmail} = this.state;

        if (redirect) {
            return <Redirect to={redirect}/>
        }

        let innerBlock = null;

        switch (modal) {
            case 'register':
                innerBlock = <ModalMenuSignupForm onRegisterSuccess={this.onRegisterSuccess} />;
                break;
            case 'confirmRegistration':
                innerBlock = <ModalMenuConfirmRegistration email={registeredEmail ? registeredEmail : (currentUser ? currentUser.email : "")}/>;
                break;
            case 'passwordRecover':
                innerBlock = <ModalMenuForgotPasswordForm/>;
                break;
            case 'passwordChange': {
                innerBlock = <ModalMenuPasswordChangeForm prt={prt}/>;
                break;
            }
            case 'login':
            default:
                if (!currentUser || !currentUser.isLoggedIn())
                    innerBlock = <ModalMenuLoginForm currentUser={currentUser} onLogin={closeFn} />;
                else
                    innerBlock = <ModalMenuUserBlock pm={pm} currentUser={currentUser} logout={this.onLogout} showDelete={showDelete} />;
                break;
        }

        // todo: social widgets

        return (
            <div>
                <Modal className="main-menu" show={show} onHide={closeFn}>
                    <Modal.Body>
                        <div className="menu-modal">
                            <div className="menu-modal-left">
                                <p className="section-title">Menu</p>
                                <nav>
                                    {/* closeFn is called here because ModalMenu is hidden only on location change, see AppContainer::componentWillReceiveProps */}
                                    <Link to="/" onClick={() => closeFn()}>{t('Home')}</Link>
                                    <Link to={paths.profiles_default.path}>{t('Profiles')}</Link>
                                    <Link to={paths.amateurFilms.toPath()}>{t('Amateur videos')}</Link>
                                    <Link to={paths.wall.path}>{t('The Wall')}</Link>
                                    <Link to={paths.wardrobe.path}>{t('The Wardrobe')}</Link>
                                    <Link to={paths.faq.path}>{t('Help')}</Link>
                                    <Link to={paths.contact.path}>{t('Contact')}</Link>
                                    <a href="/arphp/" target="_blank">{t('Links')}</a>
                                    <Link to={paths.cgu.path}>{t('CGU')}</Link>
                                    {currentUser && currentUser.isOwner() && <a href="/manage/" className="special" target="_blank">Administration</a>}
                                    <div className="choose-lang flex space-between">
                                        <LangButton locale="en"><p>En</p></LangButton>
                                        <LangButton locale="fr"><p>Fr</p></LangButton>
                                    </div>
                                </nav>
                            </div>
                            <div className="menu-modal-center">
                                {innerBlock}
                            </div>
                            <div className="menu-modal-right">
                                <p className="section-title">Les sites de Bob</p>
                                <nav>
                                    <a href="https://www.bobvoyeur.com" target="_blank">Bobvoyeur</a>
                                    <a href="https://www.bob4men.com" target="_blank">Bob4men</a>
                                    <a href="https://bobstore.fr" target="_blank">Bobstore</a>
                                    <a href="http://www.youmebob.com" target="_blank">Youmebob</a>
                                </nav>
                                <div className="blog">
                                    <a href="https://blog.bobtv.fr/" target="_blank">{t('The bobTV blog')}</a>
                                </div>
                                {/*
                                <div className="social">
                                    <div>
                                        <img src={twitterIcon} alt="icon" />
                                    </div>
                                    <div>
                                        <img src={fsIcon} alt="icon" />
                                        <span>2 170</span>
                                    </div>
                                </div>
                                */}

                                <div className="webmasters">
                                    <a href="//www.bobvoyeur.com/webmasters/" target="_blank">Webmasters</a>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}


export default connect()(ModalMenu);



// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu.js